import React from 'react';
import { Button, Popover, MenuItem, Theme } from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/styles';
import { ExpandMore } from '@material-ui/icons';
import { SortOrder } from './form-responses-types';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    toolbarButton: {
      backgroundColor: 'transparent',
      color: '#646464',
      border: '1px solid #d9d9d9',
      borderRadius: '4px',
      padding: '4.5px 12px',
      fontSize: '12px',
      fontWeight: 600,
      textTransform: 'none',
      minWidth: 'auto',
      display: 'flex',
      alignItems: 'center',
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
      },
    },
    sortMenuItem: {
      fontSize: '13px',
      padding: '8px 16px',
      '&:hover': {
        backgroundColor: theme.color.grey.neutralBrand100,
      },
    },
  })
);

interface SortPopoverProps {
  sortOrder: SortOrder;
  onSortChange: (order: SortOrder) => void;
}

export const SortPopover: React.FC<SortPopoverProps> = ({ sortOrder, onSortChange }) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

  return (
    <>
      <Button
        endIcon={<ExpandMore style={{ fontSize: '16px' }} />}
        onClick={(e) => setAnchorEl(e.currentTarget)}
        className={classes.toolbarButton}
      >
        <>
          Sort by:{' '}
          <span style={{ fontWeight: 400, marginLeft: '4px' }}>
            {sortOrder === 'newest' ? 'Newest first' : 'Oldest first'}
          </span>
        </>
      </Button>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem
          className={classes.sortMenuItem}
          onClick={() => {
            onSortChange('newest');
            setAnchorEl(null);
          }}
        >
          Newest first
        </MenuItem>
        <MenuItem
          className={classes.sortMenuItem}
          onClick={() => {
            onSortChange('oldest');
            setAnchorEl(null);
          }}
        >
          Oldest first
        </MenuItem>
      </Popover>
    </>
  );
};
